import DOMPurify from 'dompurify';
import { decode } from 'html-entities';
export const sanitize = (value, allowedTags) => DOMPurify.sanitize(value, allowedTags ? { ALLOWED_TAGS: allowedTags } : undefined);
export const decodeHtmlEntities = (value, allowedTags) => decode(sanitize(value, allowedTags), { scope: 'strict' });
